import React from 'react';

const STYLES = {
  price: 'bg-amber-100 text-amber-900',
  ready: 'bg-emerald-100 text-emerald-900',
  red_flag: 'bg-red-100 text-red-900',
  callback: 'bg-sky-100 text-sky-900',
};

export const REASON_OPTIONS = [
  { value: 'price', label: 'Price beyond limit' },
  { value: 'ready', label: 'Ready to buy / booked' },
  { value: 'red_flag', label: 'Red flag / complaint' },
  { value: 'callback', label: 'Callback requested' },
];

export const HandoffReasonBadge = ({ reason, label }) => (
  <span className={`inline-block text-[11px] font-semibold px-2 py-0.5 rounded-full ${STYLES[reason] || 'bg-stone-100 text-stone-800'}`}>
    {label}
  </span>
);

export const timeAgo = (iso) => {
  if (!iso) return '';
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', {
  day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Kolkata',
}) : '');
